// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"328":"admin","601":"insurance","608":"completeInsurance","987":"admins"}[chunkId] + "." + {"328":"44f5d4a3","601":"84b2acb4","608":"84b2acb4","987":"84b2acb4"}[chunkId] + ".css";
};